import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import './Login.css';
import god1 from '../images/god1.png';
import god2 from '../images/god2.png';
import SignUp from './SignUp';

function Login({ onLoginSuccess }) {
  const [showSignUp, setShowSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleContinueClick = () => {
    setShowSignUp(true);
  };

  const handleSignUpSuccess = () => {
    setShowSignUp(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLoginSuccess();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form-container">
          {!showSignUp && <img src={god1} alt="Deity" className="login-god-image" />}
          <div className="login-form">
            <h2>ACCOUNT LOGIN</h2>
            <h3>Login</h3>
            <form onSubmit={handleLogin}>
              <div className="input-group">
                <label htmlFor="email">Email Address *</label>
                <input 
                  type="email" 
                  id="email" 
                  placeholder="Email Address" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">Password *</label>
                <input 
                  type="password" 
                  id="password" 
                  placeholder="Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button type="button" className="forgot-password">Forgot Password?</button>
              </div>
              <button type="submit" className="btn-login">Login</button>
            </form>
          </div>
        </div>
        <div className="new-customer-container">
          {showSignUp ? (
            <SignUp onSignUpSuccess={handleSignUpSuccess} />
          ) : (
            <>
              <img src={god2} alt="Deity" className="new-customer-god-image" />
              <div className="new-customer-content">
                <h2>New Customer</h2>
                <p>By creating an account you will be able to shop faster, be up to date on an order's status, and keep track of the orders you have previously made.</p>
                <button className="btn-continue" onClick={handleContinueClick}>Continue</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
